"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var helpers_exports = {};
__export(helpers_exports, {
  invasivePlantAttr: () => invasivePlantAttr,
  moduleNumberAttr: () => moduleNumberAttr,
  moduleNumbersAttr: () => moduleNumbersAttr,
  negativeIndex: () => negativeIndex,
  particleSizeAttr: () => particleSizeAttr,
  positiveIndex: () => positiveIndex,
  riverCategoryAttr: () => riverCategoryAttr,
  riverTypeAttr: () => riverTypeAttr,
  surveyTypeAttr: () => surveyTypeAttr
});
module.exports = __toCommonJS(helpers_exports);
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_topo_map = require("@cartographerio/topo-map");
var import_lodash = require("lodash");
const moduleNumberAttr = (0, import_topo_map.numberAttr)({
  label: "Module Number",
  attributeId: "moduleNumber",
  decimalPlaces: 0,
  buckets: (0, import_lodash.range)(1, 11).map((value) => (0, import_topo_map.lookupBucket)(value, import_topo_map.marker.hue(36 * (value - 1))))
});
function moduleNumbersAttr(attributeId) {
  return (0, import_topo_map.stringAttr)({
    attributeId,
    label: "Module Numbers",
    buckets: "auto"
  });
}
const surveyTypeAttr = (0, import_topo_map.enumAttr)({
  attributeId: "surveyType",
  label: "Survey Type",
  enum: import_inventory_enums.UrsSurveyTypeEnum
});
function negativeIndex(attributeId, label) {
  return (0, import_topo_map.numberAttr)({
    attributeId,
    label,
    decimalPlaces: 3,
    buckets: [
      (0, import_topo_map.lookupBucket)(-4, import_topo_map.marker.quality(0 / 8)),
      (0, import_topo_map.lookupBucket)(-3, import_topo_map.marker.quality(1 / 8)),
      (0, import_topo_map.lookupBucket)(-2, import_topo_map.marker.quality(2 / 8)),
      (0, import_topo_map.lookupBucket)(-1, import_topo_map.marker.quality(3 / 8)),
      (0, import_topo_map.lookupBucket)(0, import_topo_map.marker.quality(4 / 8))
    ]
  });
}
function positiveIndex(attributeId, label) {
  return (0, import_topo_map.numberAttr)({
    attributeId,
    label,
    decimalPlaces: 3,
    buckets: [
      (0, import_topo_map.lookupBucket)(0, import_topo_map.marker.quality(4 / 8)),
      (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.quality(5 / 8)),
      (0, import_topo_map.lookupBucket)(2, import_topo_map.marker.quality(6 / 8)),
      (0, import_topo_map.lookupBucket)(3, import_topo_map.marker.quality(7 / 8)),
      (0, import_topo_map.lookupBucket)(4, import_topo_map.marker.quality(8 / 8))
    ]
  });
}
function particleSizeAttr(attributeId, label, includeBedrock = true) {
  const bedrockValues = includeBedrock ? [(0, import_topo_map.lookupBucket)(import_inventory_enums.MrsBedMaterialParticleSizeEnum.Bedrock, import_topo_map.marker.quality(0), "Bedrock")] : [];
  return (0, import_topo_map.stringAttr)({
    attributeId,
    label,
    buckets: [
      ...bedrockValues,
      (0, import_topo_map.lookupBucket)(import_inventory_enums.MrsBedMaterialParticleSizeEnum.Boulder, import_topo_map.marker.quality(0.1), "Boulder"),
      (0, import_topo_map.lookupBucket)(import_inventory_enums.MrsBedMaterialParticleSizeEnum.Cobble, import_topo_map.marker.quality(0.3), "Cobble"),
      (0, import_topo_map.lookupBucket)(import_inventory_enums.MrsBedMaterialParticleSizeEnum.GravelPebble, import_topo_map.marker.quality(0.5), "Gravel-Pebble"),
      (0, import_topo_map.lookupBucket)(import_inventory_enums.MrsBedMaterialParticleSizeEnum.Sand, import_topo_map.marker.quality(0.8), "Sand"),
      (0, import_topo_map.lookupBucket)(import_inventory_enums.MrsBedMaterialParticleSizeEnum.Silt, import_topo_map.marker.quality(0.9), "Silt"),
      (0, import_topo_map.lookupBucket)(import_inventory_enums.MrsBedMaterialParticleSizeEnum.Clay, import_topo_map.marker.quality(1), "Clay")
    ]
  });
}
function invasivePlantAttr(attributeId, label) {
  return (0, import_topo_map.stringAttr)({
    attributeId,
    label,
    buckets: [
      (0, import_topo_map.lookupBucket)("A", import_topo_map.marker.quality(0.8), "Absent (0% cover)"),
      (0, import_topo_map.lookupBucket)("T", import_topo_map.marker.quality(0.5), "Trace (1-4% cover)"),
      (0, import_topo_map.lookupBucket)("P", import_topo_map.marker.quality(0.3), "Present (5-33% cover)"),
      (0, import_topo_map.lookupBucket)("E", import_topo_map.marker.quality(0.1), "Extensive (>33% cover)")
    ]
  });
}
function riverTypeAttr(attributeId, label) {
  return (0, import_topo_map.enumAttr)({
    attributeId,
    label,
    enum: import_inventory_enums.MrsRtaRiverTypeEnum,
    markers: {
      Navigable: import_topo_map.marker.fromColor("#777"),
      Large: import_topo_map.marker.fromColor("#eee"),
      A: import_topo_map.marker.hue(Math.floor(360 * 0 / 12)),
      B: import_topo_map.marker.hue(Math.floor(360 * 1 / 12)),
      C: import_topo_map.marker.hue(Math.floor(360 * 2 / 12)),
      D: import_topo_map.marker.hue(Math.floor(360 * 3 / 12)),
      E: import_topo_map.marker.hue(Math.floor(360 * 4 / 12)),
      F: import_topo_map.marker.hue(Math.floor(360 * 5 / 12)),
      G: import_topo_map.marker.hue(Math.floor(360 * 6 / 12)),
      H: import_topo_map.marker.hue(Math.floor(360 * 7 / 12)),
      I: import_topo_map.marker.hue(Math.floor(360 * 8 / 12)),
      J: import_topo_map.marker.hue(Math.floor(360 * 9 / 12)),
      K: import_topo_map.marker.hue(Math.floor(360 * 10 / 12)),
      L: import_topo_map.marker.hue(Math.floor(360 * 11 / 12)),
      M: import_topo_map.marker.hue(Math.floor(360 * 12 / 12))
    }
  });
}
function riverCategoryAttr(attributeId, label) {
  return (0, import_topo_map.enumAttr)({
    attributeId,
    label,
    enum: import_inventory_enums.MrsRtaRiverCategoryEnum,
    markers: {
      Navigable: import_topo_map.marker.fromColor("#777"),
      Large: import_topo_map.marker.fromColor("#eee"),
      Other: import_topo_map.marker.fromColor("#0dd")
    }
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  invasivePlantAttr,
  moduleNumberAttr,
  moduleNumbersAttr,
  negativeIndex,
  particleSizeAttr,
  positiveIndex,
  riverCategoryAttr,
  riverTypeAttr,
  surveyTypeAttr
});
//# sourceMappingURL=helpers.js.map
